/* inspired by https://github.com/dvtng/react-loading-skeleton/blob/master/src/index.js */
import React, { Component } from 'react';

import './Skeleton.css';

export default class Skeleton extends Component {
	static defaultProps = {
		count: 1,
		lineHeight: 1,
		height: null,
		width: null,
		wrapper: null,
		duration: 1.2
	};

	render() {
		const elements = [];
		for (let i = 0; i < this.props.count; i++) {
			elements.push(
				<span
					key={i}
					className="react-loading-skeleton"
					style={{
						/*animation: "progress " + String(this.props.duration) + "s ease-in-out infinite",*/ // TODO: calc() in keyframes not supported by MS EDGE!!
						height: this.props.height,
						width: this.props.width,
						lineHeight: this.props.lineHeight
					}}
				>&zwnj;</span>
			);
		}

		const Wrapper = this.props.wrapper;
		return (
			<span>
				{ !!Wrapper
					? elements.map((element, i) => <Wrapper key={i}>{element}&zwnj;</Wrapper>)
					: elements
				}
			</span>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/common/Skeleton.jsx